import { useSelector } from "react-redux";
import "./service/AxiosService";

import { RootState } from "./store";
import { StackNavigator } from "./navigation/StackNavigator";
import apiService from "./service/ApiService";
import { useEffect, useState } from "react";
import { hooks } from "./hooks";
import { setSiteHours } from "./store/slices/screenSlice";
import { setConfig, setDisabledMenuItems, setPaymentMethod, setUserPoints } from "./store/slices/appSlice";
import constants from "./helpers/constants";
import { showErrorToast, Toast } from "./components/Toast";
import { components } from "./components";
import { clearCart } from "./store/slices/cartSlice";
import { Routes } from "./routes";
import utils from "./helpers/utils";
import { setSites as setSitesAction } from "./store/slices/screenSlice";
import { setLogout } from "./store/slices/authSlice";
import _ from "lodash";
import setSitesUtil from "./utils/setSitesUtil";
import { setIsPointsUpdate } from "./store/slices/lookupSlice";

interface GeoLocation {
  latitude: number;
  longitude: number;
}

function App() {
  const dispatch = hooks.useDispatch();
  const [geolocation, setGeolocation] = useState<GeoLocation>({
    latitude: 0,
    longitude: 0,
  });
  const selectedSiteId = useSelector((state: RootState) => state.appReducer.selectedSiteId);
  const paymentMethod = useSelector((state: RootState) => state.appReducer.paymentMethod);
  const authState = useSelector((state: RootState) => state.authReducer.auth);
  const color = useSelector((state: RootState) => state.bgSlice.color);
  const isPointsUpdate = useSelector((state: RootState) => state.lookupReducer.isPointsUpdate);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setGeolocation({
            latitude: constants.defaultLocation.latitude,
            longitude: constants.defaultLocation.longitude,
          });
        },
        (err) => {
          console.log(err.message);
        }
      );
    } else {
      console.log("Geolocation is not supported by your browser.");
    }
  }, []);

  useEffect(() => {
    getSites();
  }, []);

  useEffect(() => {
    if (authState.token || isPointsUpdate) {
      getUserInfo()
    }
  }, [isPointsUpdate]);

  const getUserInfo = async () => {
    const deviceBuildNumber = constants.appVersion;
    const { apiMode } = utils.getApiModeConfig();
    const { data } = await apiService.getUserInfoAsync(`${deviceBuildNumber}-${apiMode}`, { token: null });
    if (data) {
      if (_.isEmpty(paymentMethod) && !_.isEmpty(data.defaultPaymentMethod)) {
        const paymentMethod = {
          ...data.defaultPaymentMethod,
          payType: 'Card'
        }
        dispatch(setPaymentMethod(paymentMethod));
      }
      dispatch(setUserPoints({ userPoint: data.balance.balance }));
      dispatch(setIsPointsUpdate(false));
      dispatch(setDisabledMenuItems(data.purchasedItems));
    } else if (!data) {
      // showErrorToast(error.phone);
      dispatch(setLogout());
    } else {
      if (!utils.validateToken()) {
        showErrorToast('Registered user is currently inactive.');
        dispatch(clearCart());
      }
    }
  };

  const getSites = async () => {
    const { data } = await apiService.getSitesAsync(
      geolocation.latitude,
      geolocation.longitude,
      { packageName: process.env.PACKAGE_NAME }
    );
    if (data) {
      const sites = setSitesUtil(data, selectedSiteId);
      dispatch(setConfig(data.config));
      dispatch(setSiteHours(data.siteHours));
      dispatch(setSitesAction(sites));
    }
    setIsLoading(false);
  };

  return (
    <div id='app' style={{ backgroundColor: color }}>
      {isLoading ? (
        <components.Loader />
      ) : (
        <>
          <StackNavigator /> <Toast />
        </>
      )}
    </div>
  );
}

export default App;
